// @ts-nocheck

import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useBindActionsCreator from '../../../hooks/useBindActionsCreator';
import useMergeProps from '../../../hooks/useMergeProps';
import {
  flushKLNotifications,
  skipAllKLTemporaryNotifications,
  skipCurrentKLTemporaryNotification,
} from '../actions/kl';
import KLNotificationsViewer from '../components/KLNotificationsViewer';
import selectKLNotificationsViewerProps from '../selectors/specifics/selectKLNotificationsViewerProps';

type KLNotificationsViewerContainerProps = {
  className?: string;
};

const KLNotificationsViewerContainer = (ownProps: KLNotificationsViewerContainerProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(flushKLNotifications());
  }, [dispatch]);

  const selectedProps = useSelector(selectKLNotificationsViewerProps);
  const { notification } = selectedProps;

  const actions = useMemo(
    () => ({
      skipAll: skipAllKLTemporaryNotifications,
      skipCurrent: skipCurrentKLTemporaryNotification,
    }),
    [],
  );
  const actionsProps = useBindActionsCreator(actions);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, actionsProps });

  return notification ? <KLNotificationsViewer {...enhancedProps} /> : null;
};

export default KLNotificationsViewerContainer;
